import { Paper } from '@mui/material';
import React from 'react';

const AutocompletePaper = (props) => <Paper elevation={5} {...props} />;

export default AutocompletePaper;
